import type { MouseEvent } from 'react';

/**
 * The index (its `data-index`) of the option a click in a listbox landed on, or -1. The listbox has the
 * one click handler, so no option needs a handler of its own; keyboard choice stays on the list or its field.
 */
export function optionIndex(e: MouseEvent<HTMLElement>): number {
  const el = (e.target as Element).closest<HTMLElement>('[role="option"]');
  if (!el || !e.currentTarget.contains(el) || el.dataset.index === undefined) return -1;
  return Number(el.dataset.index);
}
